if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      
      const activeMedia = this.elements.viewer.querySelector('.is-active');
      
      this.updateSliderHeight(activeMedia)
      this.onSwipe(this.elements.viewer)
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    onSwipe(elem) {
      let touchstartX = 0;
      let touchendX = 0;
      
      const addActiveClassToSlide = () => {
        // Remove "active" class from all slides
        elem.sliderItems.forEach((slide) => {
          slide.classList.remove('active');
        });

        // Add "active" class to the slide in view that does not have "product__media-item--variant" class
        elem.sliderItems.forEach((slide) => {
          const slideRect = slide.getBoundingClientRect();
          if (slideRect.left >= 0 && slideRect.right <= window.innerWidth && slide.getBoundingClientRect().width !== 0) {
            slide.classList.add('is-active');
            this.updateSliderHeight(slide)
          }
        });
      }

      elem.slider.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX;
      });

      elem.slider.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX;
        if (touchendX < touchstartX) {
          // Left swipe
          setTimeout(function(){
            addActiveClassToSlide(elem);
          }, 1000)
        } else if (touchendX > touchstartX) {
          // Right swipe
          setTimeout(function(){
            addActiveClassToSlide(elem);
          }, 1000);
        }
      });
    }
      
    updateSliderHeight(mediaItem) {
      const resizeHandler = () => {
        const windowWidth = window.innerWidth;
        const isActive = mediaItem.classList.contains('is-active');
        const parentElement = mediaItem.parentElement;
        if (windowWidth < 768 && isActive) {
          const imageElement = mediaItem.querySelector('img,video');
          if (imageElement) {
            parentElement.style.height = imageElement.clientHeight + 'px';
          }
        } else {
          parentElement.style.height = 'initial';
        }
      };
    
      // Call the resize handler initially
      resizeHandler();
    
      // Attach the resize event listener using event delegation
      window.addEventListener('resize', resizeHandler);
    }
    
    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      
      activeMedia.classList.add('is-active');
      
      this.updateSliderHeight(activeMedia)

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }


      window.setTimeout(() => {
        if (this.elements.thumbnails) {

          // Fix for bug in iOS Safari https://developer.apple.com/forums/thread/703294

          activeMedia.parentElement.style.scrollSnapType = 'none';
          window.requestAnimationFrame(() => activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' }));
          setTimeout(() => (activeMedia.parentElement.style.scrollSnapType = 'x mandatory'), 1000);
          
          // activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }

        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      // TEMP FIX TO ALLOW ALL VIDEOS TO PLAY ON PDP PAGES
      // this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
        element.removeAttribute('aria-current');
        element.querySelector('div')?.classList.remove('border-peach-pale', 'border-solid', 'border-4');
        element.querySelector('div > div')?.classList.add('bg-green-indigo');
      });
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      // thumbnail.querySelector('button > div').classList.add('border-peach-pale', 'border-solid', 'border-4');
      thumbnail.querySelector('button > div > div')?.classList.remove('bg-green-indigo');
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const video = activeItem.querySelector('video');

      if(video) {
        video.play();
      }
      const deferredMedia = activeItem.querySelector('.deferred-media');

      if (deferredMedia) deferredMedia.loadContent(false);
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
